import React, { Component } from 'react';
import './general-error.scss'
import troubleshoot from '../../../images/troubleshoot.svg';
import docuwareLogoBig from '../../../images/DocuWareLogBig.svg';
import docuwareLogo from '../../../images/DocuWareLogo32px.svg';
import { ReactComponent as IconButtonRounded } from '../../../images/Icon-Button Rounded.svg';
import { Translation } from "react-i18next";

/**
 * An error message for general errors, with two buttons for going back to the previous page or to try reloading the page.
 */
class GeneralError extends Component {

    /** URL to DocuWare's start website. */
    static DocuWareURL: string = "https://start.docuware.com/";

    /** Redirects the user to the previous URL. If no previous URL exists, then redirects the user to the main DocuWare page.*/
    _redirectToPreviousUrl(): void {
        window.history.back();
    }

    /** Refreshes the current page, trying to correctly reload it. */
    _refreshPage(): void {
        window.location.reload();
    }

    render() {
        return (
            <div className="general-error">
                <div className="content">
                    <div className="header">
                        <div className="logo">
                            <a href={GeneralError.DocuWareURL}>
                                <img src={docuwareLogoBig} className="logo-big"></img>
                                <img src={docuwareLogo} className="logo-small"></img>
                            </a>
                        </div>
                        <IconButtonRounded className="close-icon" fill="red" onClick={this._redirectToPreviousUrl} />
                    </div>
                    <img src={troubleshoot} className="error-icon troubleshoot"></img>
                    <h1 className="message">
                        <Translation>{t => t("Sorry, something went wrong")}</Translation>
                    </h1>
                    <p className="detail">
                        <Translation>{t => t("The requested page is currently unavailable.")}</Translation>
                    </p>
                    <div className="buttons">
                        <button className="btn btn-secondary" onClick={this._redirectToPreviousUrl}>
                            <Translation>{t => t("Go back")}</Translation>
                        </button>
                        <button className="btn btn-primary" onClick={this._refreshPage}>
                            <Translation>{t => t("Try again")}</Translation>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default GeneralError;